// Mirrors the API tier model (api/src/services/quota.ts TIER_QUOTAS + billing
// price points). `id` values match the register schema's tier enum exactly.
export type TierId = "free" | "small" | "medium" | "large" | "xlarge";

export interface Tier {
  id: TierId;
  name: string;
  priceLabel: string;
  agents: number;
  channels: number;
  paid: boolean;
}

export const TIERS: Tier[] = [
  { id: "free", name: "Free", priceLabel: "£0", agents: 2, channels: 1, paid: false },
  { id: "small", name: "Small", priceLabel: "£10", agents: 5, channels: 2, paid: true },
  { id: "medium", name: "Medium", priceLabel: "£20", agents: 10, channels: 5, paid: true },
  { id: "large", name: "Large", priceLabel: "£50", agents: 20, channels: 10, paid: true },
  { id: "xlarge", name: "X-Large", priceLabel: "£100", agents: 50, channels: 50, paid: true },
];

/** tier id → display name. Single source of truth for tier labels across the app. */
export const TIER_LABEL: Record<TierId, string> = Object.fromEntries(
  TIERS.map((t) => [t.id, t.name]),
) as Record<TierId, string>;
